export interface BrowserObservabilityConfig {
  enabled: boolean
  serviceName: string
  serviceNamespace: string
  serviceVersion: string
  deploymentEnvironment: string
  exporterEndpoint: string
  tracesExporter: "otlp" | "none"
  logsExporter: "otlp" | "none"
  metricsExporter: "otlp" | "none"
  propagationOrigins: string[]
}

export function otlpSignalUrl(endpoint: string, signal: "traces" | "logs" | "metrics"): string {
  return `${endpoint.replace(/\/+$/, "")}/v1/${signal}`
}

export function sanitizeRoute(url: string): string {
  const pathname = url.split(/[?#]/, 1)[0]
  return pathname
    .split("/")
    .map((part) => (/^\d+$/.test(part) || /^[0-9a-f]{8}-[0-9a-f-]{27,}$/i.test(part) ? ":id" : part))
    .join("/") || "/"
}

export function isPropagationAllowed(url: string, allowedOrigins: string[]): boolean {
  try {
    const origin = new URL(url, window.location.origin).origin
    return origin === window.location.origin || allowedOrigins.includes(origin)
  } catch {
    return false
  }
}
